import React, { Component } from 'react';
export default class Load extends Component {
    render() {
        return <div className='c-loader'></div>
    }
}